import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=f4c4c8e2&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"
import style0 from "./Import.vue?vue&type=style&index=0&id=f4c4c8e2&prod&scoped=true&lang=scss"
import style1 from "./Import.vue?vue&type=style&index=1&id=f4c4c8e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c4c8e2",
  null
  
)

export default component.exports